var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCssLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 599.98 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .f {\n        fill: #264de4;\n      }\n\n      .g {\n        fill: #fff;\n      }\n\n      .h {\n        fill: #2965f1;\n      }\n\n      .i {\n        fill: #ebebeb;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m300,600h299.98V0h-299.98v600h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m0,600h299.98V.93H0v599.07h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "b",
    "data-name": "f",
    className: "i",
    points: "135.46 261.82 141.81 332.6 300.18 332.6 300.18 261.82 135.46 261.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "c",
    "data-name": "g",
    className: "i",
    points: "300.18 118.57 299.94 118.57 122.72 118.57 129.14 189.35 300.18 189.35 300.18 118.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "d",
    "data-name": "h",
    className: "i",
    points: "300.18 519.25 300.18 445.63 299.86 445.71 221.06 424.41 216.01 367.98 177.71 367.98 144.96 367.98 154.88 479.1 299.86 519.35 300.18 519.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e",
    "data-name": "i",
    className: "g",
    points: "387.08 332.6 378.88 424.38 299.94 445.69 299.94 519.31 445.02 479.1 446.09 467.14 462.73 280.81 464.45 261.82 477.23 118.57 299.94 118.57 299.94 189.35 399.67 189.35 393.22 261.82 299.94 261.82 299.94 332.6 387.08 332.6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssLogo);
export default __webpack_public_path__ + "static/media/css-logo.2d2ff40c4b7921e87179dc37cdf5803a.svg";
export { ForwardRef as ReactComponent };